import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    left: ReactNode;
    right: ReactNode | null;
};

export const CartGrid: FC<Props> = ({ left, right }) => {
    return (
        <div className={classnames(dibsCss.flex, dibsCss.gapLarger)}>
            <div
                style={{
                    flexGrow: 1,
                }}
            >
                {left}
            </div>
            {right && (
                <div
                    style={{
                        flexBasis: 360,
                        minWidth: 280,
                    }}
                >
                    {right}
                </div>
            )}
        </div>
    );
};
